<template>
  <div>
    <div class="avatar-list flex items-center" :class="centered ? 'tgbAvatarList--centered' : ''" data-test="producer-avatar-list">
      <transition-group
        name="slide-fade"
        class="avatar__wrapper flex items-center"
        tag="div"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <tgb-avatar
          v-for="user in filteredUsers"
          :key="user.id"
          :displayName="user.displayName"
          :profileImageUrl="user.profileImageUrl"
          :borderColor="randomColor()"
          :data-test="`producer-avatar-${user.id}`"
        />
      </transition-group>

      <div
        v-if="isOverLimit"
        class="avatar-list__overflow -ml-1 flex h-[28px] w-[28px] items-center justify-center rounded-full border-2 border-solid bg-producer-surfaceAlt text-center font-medium z-[1]"
      >
        +{{ userIds.length - max }}
      </div>
    </div>

    <slot
      v-if="!isTransitioning && (!filteredUsers || !filteredUsers.length)"
      name="noUsers"
      tag="div"
    >
      <div>There are currently no users working in this production.</div>
    </slot>
  </div>
</template>

<script>
import tgbAvatar from './tgbAvatar.vue';

import randomColor from '../../../js/utils/random-color';

export default {
  name: 'AvatarList',
  components: {
    tgbAvatar,
  },

  props: {
    users: {
      type: Array,
      default: () => [],
    },

    centered: {
      type: Boolean,
      default: false,
    },

    max: {
      type: Number,
      default: 6,
    },
  },

  data() {
    return {
      isTransitioning: false,
    };
  },

  methods: {
    randomColor,

    leave() {
      // Using the transition callbacks to track animation
      // so we don't preemptively show the empty state message
      this.isTransitioning = true;
    },

    afterLeave() {
      this.isTransitioning = false;
    },
  },

  computed: {
    userIds() {
      return [...this.users.reduce((memo, user) => memo.add(user.id), new Set())];
    },

    /**
    * De-dupe and splice list of users to only get 6 (default)
    * @returns {Array<Object>} List of users
    */
    filteredUsers() {
      return this.userIds
        .map((id) => this.users.find((u) => u.id === id))
        .slice(0, this.max);
    },

    /**
    * Whether or not there's more users than we can realistically show
    * @returns {Boolean}
    */
    isOverLimit() {
      return this.userIds.length > this.max;
    },
  },
};
</script>
